import jsmediatags from "jsmediatags/dist/jsmediatags.min.js";

function bufferToDataUrl(data, format) {
  let binary = "";
  const chunk = 8192;
  for (let i = 0; i < data.length; i += chunk) {
    binary += String.fromCharCode.apply(null, data.slice(i, i + chunk));
  }
  return `data:${format || "image/jpeg"};base64,${btoa(binary)}`;
}

export function parseMetadata(file) {
  return new Promise((resolve) => {
    let settled = false;
    const done = (r) => {
      if (!settled) {
        settled = true;
        resolve(r);
      }
    };
    setTimeout(() => done({}), 6000);
    try {
      jsmediatags.read(file, {
        onSuccess: (tag) => {
          const t = tag.tags || {};
          let cover = null;
          if (t.picture && t.picture.data) {
            try {
              cover = bufferToDataUrl(t.picture.data, t.picture.format);
            } catch (e) {
              cover = null;
            }
          }
          done({
            title: t.title || null,
            artist: t.artist || null,
            album: t.album || null,
            cover,
          });
        },
        onError: () => done({}),
      });
    } catch (e) {
      done({});
    }
  });
}
